import React, {useContext} from "react";
import {DimensionsContext} from "@common/utils/mobileUtils";
import {View} from "react-native";
import {theme} from "@common/theme/theme";
import {useSafeAreaInsets} from "react-native-safe-area-context";

export const HeaderContainerM = ({style, children, noBorder = false, noTopInset = false, forceTopInset = false}) => {
    const dimensions = useContext(DimensionsContext)
    const insets = useSafeAreaInsets();

    return <View style={{
        width: "100%",
        // height: 60,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.colors.white,
        borderBottomWidth: noBorder ? 0 : 1,
        borderColor: theme.colors.lightMore,
        // Edge-to-edge is always on in SDK 54 (Android included), so apply the
        // top safe-area inset on every platform — not just iOS — to keep the
        // header content below the status bar.
        paddingTop: ((!noTopInset) || forceTopInset) ? insets.top : 0
    }}>
        <View style={{
            width: dimensions?.width,
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            height: 60,
            ...style
        }}>
            {children}
        </View>
    </View>
}